import React from 'react'
import './EmptyCart.css'
import { handleRedirectInternal } from '@/product/common/components'
import { useHistory } from 'react-router-dom'
import PrimaryButton from '@/product/components/atoms/PrimaryButton'

function EmptyCart() {
    const history = useHistory()

    return (
        <div className="emptyCart container d-flex justify-content-between flex-wrap text-center">
            <img className="emptyCartImg" src="./assets/svg/emptyState.svg" />
            <div className="emptyCartActions w-100">
                <h2>{'You have no offers in your cart'}</h2>
                {/* <h4>{'Search our inventory for amazing products'}</h4> */}
                {/* <PrimaryButton
                    id="emptyCart"
                    label={'search for products'}
                    onClick={() => handleRedirectInternal(history, 'search')}
                /> */}
            </div>
        </div>
    )
}

export default EmptyCart
